<template>
  <v-flex class="mb-4 pa-5">
    <h1 class="display-1 font-weight-bold">
      How To Get WISE
    </h1>

    <p class="mt-5">
        There are three ways to get WISE in the first place or to get more WISE if you already own some of it.
        <ul>
          <li>Buy WISE on an exchange</li>
          <li>Refer new stakes</li>
          <li>Get Interest from your WISE stakes</li>
        </ul>
    </p>

    <h2>3 Ways to Get WISE</h2>
    <h3>Buying on an exchange</h3>
    <p>
      The best way to buy WISE is using <a href="https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x66a0f676479cee1d7373f3dc2e2952778bff5bd6">Uniswap</a>. Almost all the liquidity is there, which allows big trades with very low slippage
    </p>
    <h3>Receiving Referrals</h3>
    <p>
      Get other people to use your referral link before staking their WISE, similar to this one: <ReferrerLink /> For more detailed info about the referral system check the official whitepaper on <ReferrerLinkWhitepaper />
    </p>
    <h3>Get Interest from your WISE stakes</h3>
    <p>By staking your WISE, you will earn currently arround 10% APY in WISE. Stake your WISE <ReferrerLinkStaking>here</ReferrerLinkStaking> or check out my guide <v-btn to="/howtostakewise">How To Stake Wise</v-btn></p>
    <h2>Other resources</h2>
    <p>Check out this video from the official Wise Staking Youtube Channel: <v-btn href="https://youtu.be/hlEAnVl4-_8" target="_blank" outlined small>https://youtu.be/hlEAnVl4-_8</v-btn></p>

  </v-flex>
</template>

<script>

  import ReferrerLinkWhitepaper from "@/components/ReferrerLinkWhitepaper.vue"
  import ReferrerLinkStaking from "@/components/ReferrerLinkStaking.vue"
  import ReferrerLink from "@/components/ReferrerLink.vue"

  export default {
    name: "HowToGetWise",
    data() {
      return {

      }
    },
    components: {
      ReferrerLink,
      ReferrerLinkWhitepaper,
      ReferrerLinkStaking
    },
  };
</script>

<style>
</style>
